export default __webpack_public_path__ + "static/media/byd-logo-small.23bf06e3.png";